module.exports = __webpack_public_path__ + "img/odr_system_header.4239b12f.png";